//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { useEffect, useRef } from 'react';
import { useHelp } from '@/hooks/useHelp';

/**
 * HelpInitializer - Ensures help effects are properly initialized.
 */
const HelpInitializer = () => {
  const {
    helpState: { helpInitialized },
    helpActions: { startInactivityTimer, setHelpInitialized }
  } = useHelp();

  const hasInitialized = useRef(false);

  // Initial app startup behavior
  useEffect(() => {
    if (hasInitialized.current) return;

    hasInitialized.current = true;

    if (!helpInitialized) {
      startInactivityTimer({
        timerSeconds: 5,
        label: 'app-launch'
      });
      setHelpInitialized(true);
      return;
    }
  }, [startInactivityTimer, helpInitialized, setHelpInitialized]);

  return null;
};

export default HelpInitializer;
